module.exports = __webpack_public_path__ + "img/install2_arrow.6e211d19.jpg";